import {motion} from 'framer-motion';
import {darken, lighten} from 'polished';
import styled, {keyframes} from 'styled-components';

const zoomAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
`;

export const CircleContainer = styled.div`
  max-width: 100vw;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px; 
`;

export const HeaderContainer = styled.div`
  height: 8vh;
  width: 100%;
  display: flex;
`;

export const MiddleContainer = styled.div`
  display: flex;
  align-items: flex-start;
  height: 70vh;
  background-color: pink;
  background-color: #0f4166;
  background-color: ${lighten(0.2, '#023d59')};
  // background-color: ${darken(0.05, '#023d59')};
  // background-color: ${({theme}) => theme.colors.background1};
  background-color: #0D1B2A;
// background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 1000'%3E%3Cg %3E%3Ccircle fill='%230D1B2A' cx='50' cy='0' r='50'/%3E%3Cg fill='%230d1e30' %3E%3Ccircle cx='0' cy='50' r='50'/%3E%3Ccircle cx='100' cy='50' r='50'/%3E%3C/g%3E%3Ccircle fill='%230e2136' cx='50' cy='100' r='50'/%3E%3Cg fill='%230e243b' %3E%3Ccircle cx='0' cy='150' r='50'/%3E%3Ccircle cx='100' cy='150' r='50'/%3E%3C/g%3E%3Ccircle fill='%230f2741' cx='50' cy='200' r='50'/%3E%3Cg fill='%230f2a48' %3E%3Ccircle cx='0' cy='250' r='50'/%3E%3Ccircle cx='100' cy='250' r='50'/%3E%3C/g%3E%3Ccircle fill='%23102e4e' cx='50' cy='300' r='50'/%3E%3Cg fill='%23113154' %3E%3Ccircle cx='0' cy='350' r='50'/%3E%3Ccircle cx='100' cy='350' r='50'/%3E%3C/g%3E%3Ccircle fill='%2312345a' cx='50' cy='400' r='50'/%3E%3Cg fill='%23143761' %3E%3Ccircle cx='0' cy='450' r='50'/%3E%3Ccircle cx='100' cy='450' r='50'/%3E%3C/g%3E%3Ccircle fill='%23163a67' cx='50' cy='500' r='50'/%3E%3Cg fill='%23183d6d' %3E%3Ccircle cx='0' cy='550' r='50'/%3E%3Ccircle cx='100' cy='550' r='50'/%3E%3C/g%3E%3Ccircle fill='%231b4074' cx='50' cy='600' r='50'/%3E%3Cg fill='%231e437a' %3E%3Ccircle cx='0' cy='650' r='50'/%3E%3Ccircle cx='100' cy='650' r='50'/%3E%3C/g%3E%3Ccircle fill='%23214681' cx='50' cy='700' r='50'/%3E%3Cg fill='%23254987' %3E%3Ccircle cx='0' cy='750' r='50'/%3E%3Ccircle cx='100' cy='750' r='50'/%3E%3C/g%3E%3Ccircle fill='%23284c8e' cx='50' cy='800' r='50'/%3E%3Cg fill='%232d4f94' %3E%3Ccircle cx='0' cy='850' r='50'/%3E%3Ccircle cx='100' cy='850' r='50'/%3E%3C/g%3E%3Ccircle fill='%2331529b' cx='50' cy='900' r='50'/%3E%3Cg fill='%233655a1' %3E%3Ccircle cx='0' cy='950' r='50'/%3E%3Ccircle cx='100' cy='950' r='50'/%3E%3C/g%3E%3Ccircle fill='%233B58A8' cx='50' cy='1000' r='50'/%3E%3C/g%3E%3C/svg%3E");
// background-attachment: fixed;
// background-size: contain;

// background-color: #0d1d2f;
// background-color: #1e437a;
// background-color: #214681;
// background-color: #183d6d;

  background-color: ${lighten(0.2, '#023d59')};
  background-color: ${darken(0.05, '#023d59')};


  margin: 10px;
  margin-bottom: 1px;
  margin-top: 3px;
  border-radius: 10px;
`;

export const MiddleContainer1 = styled.div`
  // background-color: blue;
  flex: 1;
  display: flex;
  margin: 10px;
  margin-top: 15px;
  margin-left: 5px;
`;

export const MiddleContainer2 = styled.div`
  // background-color: green;
  flex: 1;
  display: flex; 
  justify-content:center;
  // box-sizing: border-box;
  ailign-items: center;
  height: 100%;
`;

export const MiddleContainer3 = styled.div`
   background-color: red;
  flex: 1;
  display: flex;
  padding-top: 10px;
  flex-direction: column;  
  align-items: end;     
  height: 100%;          
`;

export const MiddleContainer7 = styled.div`
  //  background-color: red;
  flex: 1;
  display: flex;
  padding-top: 10px;
  flex-direction: column;  
  // align-items: end;     
  height: 100%;          
`;

export const MiddleContainer7Row = styled.div`
  display: flex;
  padding-top: 5px;
  flex-direction: reverse-row;  
  align-items: center;     
  height: 10vw;          
`;
export const MiddleContainer7Row2 = styled.div`
  display: flex;
  padding-bottom: 5px;
  flex-direction: reverse-row;  
  align-items: center;     
  height: 5vw;          
`;

export const MiddleContainer7RowCell = styled.button`
   flex: 1;   
  height: 100%;      
  margin: 5px; 
  background-color:  ${(props) => props.backgroundcolor || props.theme.colors.background50};
  margin-bottom: 10px;
  border: none;
  border-radius: 8px;
  font-weight: bold;
  font-family: text2;
  font-size: 1rem;
  color: ${({theme}) => theme.colors.textColor2}; 
  visibility: ${props => (props.invisible === "true" && 'hidden')};
`;

export const MiddleContainer7RowCellAnimation = styled.button`
   flex: 1;   
  height: 100%;      
  margin: 5px; 
  background-color:  ${(props) => props.backgroundcolor || props.theme.colors.background50};
  margin-bottom: 10px;
  border: none;
  border-radius: 8px;
  font-weight: bold;
  font-family: text2;
  font-size: 1rem;
  color: ${({theme}) => theme.colors.textColor2}; 
  visibility: ${props => (props.invisible === "true" && 'hidden')};
   transition: transform 0.2s ease-in-out;
  // animation:${props => (props.animation === "true" && 'hidden')};
   animation : ${zoomAnimation} 1s ease-in-out infinite
`;


export const SquareButton = styled.button`
 width: 11vw; 
  height: 11vw;
  background-color:  ${(props) => props.backgroundcolor || props.theme.colors.background50};
  margin-bottom: 10px;
  border: none;
  margin: 5px;
  border-radius: 8px;
  font-weight: bold;
  font-family: text2;
  font-size: 1rem;
  color: ${({theme}) => theme.colors.textColor2};
`;

export const SquareButtonLimit = styled.div`
  // background-color: #3498db;
  cursor: pointer;
  color: ${({theme}) => theme.colors.textColor1};
  display: flex;
  justify-content: center;
  flex: 1;   
  height: 100%;      
  margin: 5px; 
  font-weight: bold;
  font-family: text2;
  font-size: 1rem;
  visibility: ${props => (props.invisible === "true" && 'hidden')};
`;

export const NumberList = styled.ul`
  list-style-type: none; /* Removes the default bullet points */
  padding: 0;
  margin: 0;
  font-family: text7;
  font-weight: bold;
`;

export const NumberItem = styled.li`
  margin-bottom: 1px;
  padding: 1px;
`;

export const HighlightSpan = styled.span`
  color: blue; 
  font-weight: bold; 
`;

export const NumberValue = styled.span`
  color: ${({theme}) => theme.colors.textColor1};
  font-weight: bold; 
  font-size: 1rem;
  font-family: text7;
  font-weight: bold;
  // border-bottom: 1px solid black;
  padding: 5px;
  padding-right: 10px;
  margin-left: 5px;
`;

export const NumberValue2 = styled.span`
  color: ${({theme}) => theme.colors.textColor1};
  font-weight: bold; 
  font-size: 0.8rem;
  font-family: text7;
  border-radius: 2px;
  padding: 2px;
  margin-bottom:5px;
  // background-color: #03384f;
  // background-color: ${({theme}) => theme.colors.background3};
  padding-left: 5px;
  padding-right: 5px;
  // border: 0.1px solid #0d1b2a;

// background-color: #0d1b2a;
// color: #6fe6ec;
// color: #0d1b2a;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.4), 0 2px 4px rgba(0, 0, 0, 0.06);

`;

export const StyledNumber = styled.span`
  color: blue; 
  font-weight: bold; 
`;

export const EmphasisSpan = styled.span`
  color: blue; 
  font-weight: bold; 
`;


export const Circle = styled(motion.div)`
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin: 10px;
    cursor: pointer;
`;

export const Header = styled.div`
    display: flex;
    height: 8vh;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
    /* background-color: red; */
`;

export const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  aign-items: center;
  jcustify-content: center;
  box-sizing: border-box; 
  /* align-items: center; */
  /* justify-content: center; */
  height: 100vh;
  width: 100%;
  // margin: 0;
  // background-color: #121926;
  // background: linear-gradient(to bottom, #1a1a2e, #2d2d44, #4a4e69);
  // background: linear-gradient(to bottom, #151e23, #2d2d44, #4a4e69);
  // background-color: rgb(13,22,29);
      background-color: #023d59;
      // background-color: #061421;
    background-color: ${({theme}) => theme.colors.background1};

    position: absolute;
    // border: 5px solid white;

//       background-color: #67D3DB;
// background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25' viewBox='0 0 1600 800'%3E%3Cg %3E%3Cpolygon fill='%23264955' points='1600 160 0 460 0 350 1600 50'/%3E%3Cpolygon fill='%233f767f' points='1600 260 0 560 0 450 1600 150'/%3E%3Cpolygon fill='%2357a4aa' points='1600 360 0 660 0 550 1600 250'/%3E%3Cpolygon fill='%2370d1d4' points='1600 460 0 760 0 650 1600 350'/%3E%3Cpolygon fill='%2389FFFF' points='1600 800 0 800 0 750 1600 450'/%3E%3C/g%3E%3C/svg%3E");
// background-attachment: fixed;
// background-size: cover;


// background-color: #67D3DB;
// background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25' viewBox='0 0 800 800'%3E%3Cg %3E%3Ccircle fill='%2367D3DB' cx='400' cy='400' r='600'/%3E%3Ccircle fill='%233abdd7' cx='400' cy='400' r='500'/%3E%3Ccircle fill='%2300a5d2' cx='400' cy='400' r='400'/%3E%3Ccircle fill='%23008dca' cx='400' cy='400' r='300'/%3E%3Ccircle fill='%231673bc' cx='400' cy='400' r='200'/%3E%3Ccircle fill='%233B58A8' cx='400' cy='400' r='100'/%3E%3C/g%3E%3C/svg%3E");
// background-attachment: fixed;
// background-size: cover;


// background-color: #0D1B2A;
// background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 1000'%3E%3Cg %3E%3Ccircle fill='%230D1B2A' cx='50' cy='0' r='50'/%3E%3Cg fill='%230d1e30' %3E%3Ccircle cx='0' cy='50' r='50'/%3E%3Ccircle cx='100' cy='50' r='50'/%3E%3C/g%3E%3Ccircle fill='%230e2136' cx='50' cy='100' r='50'/%3E%3Cg fill='%230e243b' %3E%3Ccircle cx='0' cy='150' r='50'/%3E%3Ccircle cx='100' cy='150' r='50'/%3E%3C/g%3E%3Ccircle fill='%230f2741' cx='50' cy='200' r='50'/%3E%3Cg fill='%230f2a48' %3E%3Ccircle cx='0' cy='250' r='50'/%3E%3Ccircle cx='100' cy='250' r='50'/%3E%3C/g%3E%3Ccircle fill='%23102e4e' cx='50' cy='300' r='50'/%3E%3Cg fill='%23113154' %3E%3Ccircle cx='0' cy='350' r='50'/%3E%3Ccircle cx='100' cy='350' r='50'/%3E%3C/g%3E%3Ccircle fill='%2312345a' cx='50' cy='400' r='50'/%3E%3Cg fill='%23143761' %3E%3Ccircle cx='0' cy='450' r='50'/%3E%3Ccircle cx='100' cy='450' r='50'/%3E%3C/g%3E%3Ccircle fill='%23163a67' cx='50' cy='500' r='50'/%3E%3Cg fill='%23183d6d' %3E%3Ccircle cx='0' cy='550' r='50'/%3E%3Ccircle cx='100' cy='550' r='50'/%3E%3C/g%3E%3Ccircle fill='%231b4074' cx='50' cy='600' r='50'/%3E%3Cg fill='%231e437a' %3E%3Ccircle cx='0' cy='650' r='50'/%3E%3Ccircle cx='100' cy='650' r='50'/%3E%3C/g%3E%3Ccircle fill='%23214681' cx='50' cy='700' r='50'/%3E%3Cg fill='%23254987' %3E%3Ccircle cx='0' cy='750' r='50'/%3E%3Ccircle cx='100' cy='750' r='50'/%3E%3C/g%3E%3Ccircle fill='%23284c8e' cx='50' cy='800' r='50'/%3E%3Cg fill='%232d4f94' %3E%3Ccircle cx='0' cy='850' r='50'/%3E%3Ccircle cx='100' cy='850' r='50'/%3E%3C/g%3E%3Ccircle fill='%2331529b' cx='50' cy='900' r='50'/%3E%3Cg fill='%233655a1' %3E%3Ccircle cx='0' cy='950' r='50'/%3E%3Ccircle cx='100' cy='950' r='50'/%3E%3C/g%3E%3Ccircle fill='%233B58A8' cx='50' cy='1000' r='50'/%3E%3C/g%3E%3C/svg%3E");
// background-attachment: fixed;
// background-size: contain;

// background-color: #0D1B2A;
// background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 1000'%3E%3Cg %3E%3Ccircle fill='%230D1B2A' cx='50' cy='0' r='50'/%3E%3Cg fill='%23112233' %3E%3Ccircle cx='0' cy='50' r='50'/%3E%3Ccircle cx='100' cy='50' r='50'/%3E%3C/g%3E%3Ccircle fill='%23152a3c' cx='50' cy='100' r='50'/%3E%3Cg fill='%23193245' %3E%3Ccircle cx='0' cy='150' r='50'/%3E%3Ccircle cx='100' cy='150' r='50'/%3E%3C/g%3E%3Ccircle fill='%231d3a4e' cx='50' cy='200' r='50'/%3E%3Cg fill='%23214357' %3E%3Ccircle cx='0' cy='250' r='50'/%3E%3Ccircle cx='100' cy='250' r='50'/%3E%3C/g%3E%3Ccircle fill='%23254b61' cx='50' cy='300' r='50'/%3E%3Cg fill='%2329546a' %3E%3Ccircle cx='0' cy='350' r='50'/%3E%3Ccircle cx='100' cy='350' r='50'/%3E%3C/g%3E%3Ccircle fill='%232d5d73' cx='50' cy='400' r='50'/%3E%3Cg fill='%2330667d' %3E%3Ccircle cx='0' cy='450' r='50'/%3E%3Ccircle cx='100' cy='450' r='50'/%3E%3C/g%3E%3Ccircle fill='%23346f86' cx='50' cy='500' r='50'/%3E%3Cg fill='%2338798f' %3E%3Ccircle cx='0' cy='550' r='50'/%3E%3Ccircle cx='100' cy='550' r='50'/%3E%3C/g%3E%3Ccircle fill='%233c8298' cx='50' cy='600' r='50'/%3E%3Cg fill='%23408ca1' %3E%3Ccircle cx='0' cy='650' r='50'/%3E%3Ccircle cx='100' cy='650' r='50'/%3E%3C/g%3E%3Ccircle fill='%234596aa' cx='50' cy='700' r='50'/%3E%3Cg fill='%234aa0b3' %3E%3Ccircle cx='0' cy='750' r='50'/%3E%3Ccircle cx='100' cy='750' r='50'/%3E%3C/g%3E%3Ccircle fill='%234faabb' cx='50' cy='800' r='50'/%3E%3Cg fill='%2354b4c3' %3E%3Ccircle cx='0' cy='850' r='50'/%3E%3Ccircle cx='100' cy='850' r='50'/%3E%3C/g%3E%3Ccircle fill='%235abecb' cx='50' cy='900' r='50'/%3E%3Cg fill='%2360c9d3' %3E%3Ccircle cx='0' cy='950' r='50'/%3E%3Ccircle cx='100' cy='950' r='50'/%3E%3C/g%3E%3Ccircle fill='%2367D3DB' cx='50' cy='1000' r='50'/%3E%3C/g%3E%3C/svg%3E");
// background-attachment: fixed;
// background-size: contain;

////

// background-color: #0D1B2A;
// background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 1000'%3E%3Cg %3E%3Ccircle fill='%230D1B2A' cx='50' cy='0' r='50'/%3E%3Cg fill='%230d1e30' %3E%3Ccircle cx='0' cy='50' r='50'/%3E%3Ccircle cx='100' cy='50' r='50'/%3E%3C/g%3E%3Ccircle fill='%230e2136' cx='50' cy='100' r='50'/%3E%3Cg fill='%230e243b' %3E%3Ccircle cx='0' cy='150' r='50'/%3E%3Ccircle cx='100' cy='150' r='50'/%3E%3C/g%3E%3Ccircle fill='%230f2741' cx='50' cy='200' r='50'/%3E%3Cg fill='%230f2a48' %3E%3Ccircle cx='0' cy='250' r='50'/%3E%3Ccircle cx='100' cy='250' r='50'/%3E%3C/g%3E%3Ccircle fill='%23102e4e' cx='50' cy='300' r='50'/%3E%3Cg fill='%23113154' %3E%3Ccircle cx='0' cy='350' r='50'/%3E%3Ccircle cx='100' cy='350' r='50'/%3E%3C/g%3E%3Ccircle fill='%2312345a' cx='50' cy='400' r='50'/%3E%3Cg fill='%23143761' %3E%3Ccircle cx='0' cy='450' r='50'/%3E%3Ccircle cx='100' cy='450' r='50'/%3E%3C/g%3E%3Ccircle fill='%23163a67' cx='50' cy='500' r='50'/%3E%3Cg fill='%23183d6d' %3E%3Ccircle cx='0' cy='550' r='50'/%3E%3Ccircle cx='100' cy='550' r='50'/%3E%3C/g%3E%3Ccircle fill='%231b4074' cx='50' cy='600' r='50'/%3E%3Cg fill='%231e437a' %3E%3Ccircle cx='0' cy='650' r='50'/%3E%3Ccircle cx='100' cy='650' r='50'/%3E%3C/g%3E%3Ccircle fill='%23214681' cx='50' cy='700' r='50'/%3E%3Cg fill='%23254987' %3E%3Ccircle cx='0' cy='750' r='50'/%3E%3Ccircle cx='100' cy='750' r='50'/%3E%3C/g%3E%3Ccircle fill='%23284c8e' cx='50' cy='800' r='50'/%3E%3Cg fill='%232d4f94' %3E%3Ccircle cx='0' cy='850' r='50'/%3E%3Ccircle cx='100' cy='850' r='50'/%3E%3C/g%3E%3Ccircle fill='%2331529b' cx='50' cy='900' r='50'/%3E%3Cg fill='%233655a1' %3E%3Ccircle cx='0' cy='950' r='50'/%3E%3Ccircle cx='100' cy='950' r='50'/%3E%3C/g%3E%3Ccircle fill='%233B58A8' cx='50' cy='1000' r='50'/%3E%3C/g%3E%3C/svg%3E");
// background-attachment: fixed;
// background-size: contain;

// background-color: #67D3DB;
// background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25' viewBox='0 0 800 800'%3E%3Cg %3E%3Ccircle fill='%2367D3DB' cx='400' cy='400' r='600'/%3E%3Ccircle fill='%233abdd7' cx='400' cy='400' r='500'/%3E%3Ccircle fill='%2300a5d2' cx='400' cy='400' r='400'/%3E%3Ccircle fill='%23008dca' cx='400' cy='400' r='300'/%3E%3Ccircle fill='%231673bc' cx='400' cy='400' r='200'/%3E%3Ccircle fill='%233B58A8' cx='400' cy='400' r='100'/%3E%3C/g%3E%3C/svg%3E");
// background-attachment: fixed;
// background-size: cover;

      // background-color: #0d1d2f;
//  - #04456a 




`;

export const Container1 = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    height: 20vh;
    /* background-color: green; */
`;
export const Container11 = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 35vh;
    /* background-color: green; */
`;
export const Container111 = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /* justify-content: space-around; */
    height: 40vh;
    background-color: green;
`;

export const Container2 = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    /* justify-content: center; */
    height: 50vh;
    /* margin: 0; */
`;

export const RandomizeButton = styled.button`
    margin-top: 100px;
    padding: 15px 20px;
    font-size: 18px;
    font-weight: bold;
    background-color: #003366; /* Green background color */
    color: white; /* White text color */
    border: none; /* No border */
    border-radius: 6px; /* Rounded corners */
    cursor: pointer;
    border-radius: 10px;
    transition: background-color 0.3s ease; /* Smooth color transition */ 
    &:hover {
      /* background-color: #45a049; Darker green color on hover */
    }
`;

export const MatchingCountLabel = styled.div`
    font-size: 1rem;
    font-weight: bold;
    /* margin-bottom: 10px; */
    color: white;
    margin-top: 50px;
`;

export const MatchingCountLabel1 = styled.h1`
    font-size: 2.5rem;
    color: white;
    border: 4px solid #003366;
    padding-right: 30px;
    padding-left: 30px;
    border-radius: 50px;
    border-radius: 50px;
    font-family: Pixel;

`;

export const CurrentNumber = styled.p`
display: flex;
align-items: center;
    font-size: 3rem;
  color: ${({theme}) => theme.colors.textColor1};
    font-weight: bold;
    text-align: center;
    font-family: text4;
    // border: 1px solid #003366;
    padding:15px;
    border-radius: 15px;
    // background-color: #003366;
   `;


export const BottomLeftText = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  margin: 0.5rem;
  color: #F5F5F5;  // Set your desired text color: ;
  font-size: 1rem;  // Set your desired font size
`;

export const HomePageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 50px;
  width: 100%;
  height: 100%; 
  box-sizing: border-box; 
  // background: linear-gradient(to bottom, #ff0000, #00ff00);
  // background: radial-gradient(circle, #ff0000, #00ff00);
  // background: repeating-linear-gradient(45deg, #ff0000, #ff0000 20px, #00ff00 20px, #00ff00 40px);
  // background: linear-gradient(to bottom, #FF6B6B, #FFE066);
  // background: linear-gradient(to bottom, #1a1a2e, #2d2d44, #4a4e69);
    // background-color: rgb(13,22,29);
    background-color: ${({theme}) => theme.colors.background1};

    // border: 1px solid white;  

`;

